.discord-time {
	background-color: #ffffff0f;
	border-radius: 3px;
	padding: 0 2px;
}
